import React from 'react';
import { Button, NewModal as Modal, themes } from '@digitools/honest-react';
import { workStatesModel, workProvincesModel } from '../../../filter-my-report/work-location-model/initialStateAndProvinces';
import WorkLocations from '../../../filter-my-report/work-location-model/workLocations';
import { useDisclosure } from '@mantine/hooks';
const noop = () => { };
const WorkLocationModalView = ({ prevSelectedStates, prevSelectedProvinces }) => {
    workStatesModel.map((workStateModel) => {
        workStateModel.checked = prevSelectedStates.filter(prevSelectedStates => prevSelectedStates.stateCode === workStateModel.stateCode).length > 0;
    });
    workProvincesModel.map((workProvinceModel) => {
        workProvinceModel.checked = prevSelectedProvinces.filter(prevSelectedLocations => prevSelectedLocations.provinceCode === workProvinceModel.provinceCode).length > 0;
    });
    const [isOpen, { open, close }] = useDisclosure(false);
    return (<>
      <Modal withCloseButton={false} title='Employee work location' theme={themes.rebrand} closeOnClickOutside={true} centered={true} opened={isOpen} onClose={() => {
            close();
        }} cancelButtonText={'Close'} cancelButtonProps={{
            buttonType: 'primary',
            'aria-label': 'close employee work location modal'
        }} submitButton={false}>
        <WorkLocations onStateSelect={noop} onProvinceSelect={noop} onClearAllState={noop} onClearAllProvince={noop} workStates={workStatesModel} workProvinces={workProvincesModel} disableForm={true}/>
      </Modal>
      <Button buttonType={'text'} type={'button'} onClick={open}>
        View work locations
      </Button>
    </>);
};
export default WorkLocationModalView;
